import PropTypes from 'prop-types';
import React from 'react';

import getClassName from 'src/common/utils/getClassName';
import { TITLE } from '../../constants';
import s from './Logo.module.scss';

const LogoImage = ({ classNameModifier }) => (
  <svg className={s.image}>
    <title>
      {TITLE.PROJECT}
    </title>
    <use
      xlinkHref="#logo"
      className={getClassName(s, 'icon', classNameModifier)}
    />
    <use
      xlinkHref="#text_logo"
      className={getClassName(s, 'text', classNameModifier)}
    />
  </svg>
);

LogoImage.propTypes = {
  classNameModifier: PropTypes.string,
};

export default LogoImage;
